import React from 'react';
import "./index.scss";
import styles from "./index.module.scss";
import classNames from "classnames";
import { Col, Row } from "antd";
import ReactDOM from 'react-dom'
import ModalVideo from 'react-modal-video'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay } from '@fortawesome/free-solid-svg-icons'

import HowDoISave from './images/8-b-05217840-aa-829-faf-00701-f-61-e-0-bbdb.png';
import HowDoISave2x from './images/8-b-05217840-aa-829-faf-00701-f-61-e-0-bbdb@2x.png';
import HowDoISave3x from './images/8-b-05217840-aa-829-faf-00701-f-61-e-0-bbdb@3x.png';
import WhatPayFor from './images/hp-1-b-91-a-997-c-3-b-058-f-47-c-6-a-386-f-573-cd-1-da-1-f-3-a-9-fe-2.png';
import WhatPayFor2x from './images/hp-1-b-91-a-997-c-3-b-058-f-47-c-6-a-386-f-573-cd-1-da-1-f-3-a-9-fe-2@2x.png';
import WhatPayFor3x from './images/hp-1-b-91-a-997-c-3-b-058-f-47-c-6-a-386-f-573-cd-1-da-1-f-3-a-9-fe-2@3x.png';
import TooMuchInk from './images/too-much-ink.png';
import TooMuchInk2x from './images/too-much-ink@2x.png';
import TooMuchInk3x from './images/too-much-ink@3x.png';

let cx = classNames.bind(styles);

class HowItWorks extends React.Component {
    constructor() {
        super();
        this.state = {
            isOpen: false
        }
        this.openModal = this.openModal.bind(this);
    }

    openModal() {
        this.setState({ isOpen: true });
    }

    render(props) {
        return (
            <div className={styles.howItWorks}>
                <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='AzdBLZ2FKcs' onClose={() => this.setState({isOpen: false})} />

                <div className={styles.howItWorksHeading}>
                    For a low monthly payment
                </div>
                <div className={styles.howItWorksSubHeading}>
                    Your printer automatically lets us know when you run low on ink.
                </div>
                
                
                <Row type="flex" justify="center" align="middle">
                    <Col md={6} lg={5} xl={5}>
                        <div className={styles.howItWorksItemIcon}>
                            <img src={TooMuchInk} alt="What If I receive Too Much?"
                                 srcSet={`${TooMuchInk2x} 2x,
                                         ${TooMuchInk3x} 3x`}/>
                        </div>
                    </Col>
                    <Col md={{offset: 2, span: 6}} lg={{offset:1, span: 5}} xl={{offset:1, span: 5}}>
                        <div className={styles.howItWorksItemIcon}>
                            <img src={HowDoISave} alt="How Do I Save?"
                                 srcSet={`${HowDoISave2x} 2x,
                                         ${HowDoISave3x} 3x`}/>
                        </div>
                    </Col>
                    <Col md={{offset: 2, span: 6}} lg={{offset:1, span: 5}} xl={{offset:1, span: 5}}>
                        <div className={styles.howItWorksItemIcon}>
                            <img src={WhatPayFor} alt="What Am I Paying For?"
                                 srcSet={`${WhatPayFor2x} 2x,
                                         ${WhatPayFor3x} 3x`}/>
                        </div>
                    </Col>
                </Row>
                
                <Row type="flex" justify="center">
                    <Col md={6} lg={5} xl={5}>
                        <div className={styles.howItWorksItemHeader}>Get Ink</div>
                        <div className={styles.howItWorksItemText}>Black and color ink arrive to your door before your run out.</div>
                    </Col>
                    <Col md={{offset: 2, span: 6}} lg={{offset:1, span: 5}} xl={{offset:1, span: 5}}>
                        <div className={styles.howItWorksItemHeader}>Monitor Usage</div>
                        <div className={styles.howItWorksItemText}>Take control of your printing and maximize your savings.</div>
                    </Col>
                    <Col md={{offset: 2, span: 6}} lg={{offset:1, span: 5}} xl={{offset:1, span: 5}}>
                        <div className={styles.howItWorksItemHeader}>Recycle Cartridges</div>
                        <div className={styles.howItWorksItemText}>Use our prepaid envelopes to send empty cartridges back for recycling.</div>
                    </Col>
                </Row>
                
                <Row type="flex" justify="center" className={styles.btnGroup}>
                    <Col md={{span: 12}}>
                        <a href="#" onClick={(evt) => {evt.preventDefault(); this.openModal();}} className={cx(styles.btn, styles.btnOutline, styles.watchVideoBtn)}>
                            Watch The Video
                            <span className={styles.playIcon}><FontAwesomeIcon icon={faPlay} /></span>
                        </a>
                        <a href="#plans" onClick={(evt) => { evt.preventDefault(); document.getElementById('plans').scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"}); }} className={cx(styles.btn, styles.btnOutline, styles.viewPlans)}>
                            View plans
                        </a>
                    </Col>
                </Row>
            </div>
        );
    }
}
export default HowItWorks;
